import { constant } from "lodash";

export const REPORT_ID = 'slide-15';
export const SLIDE_NUMBER = 15;